<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <cuenta-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CuentaShowData from "./CuentaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "CuentaShow",
        components: {CrudShow, CuentaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.cuenta.showing',
            }
        },
    }
</script>

